import { Action } from '@ngrx/store';
import { SearchCriteria } from '../models/search-criteria';
import { SearchResult } from '../models/search-result';
import { KvItem } from '../../core/models/kv-item';
import { DownloadedDocument } from '../../document/models/downloaded-document';
import { DocumentDetail } from '../models/document-detail';
import { DocumentMaster } from 'app/modules/document/models/document-master';

export const SEARCH_DOCUMENTS = '[Search] Search Documents';
export const SEARCH_DOCUMENTS_COMPLETE = '[Search] Search Documents Complete';
export const DOWNLOAD_FILE = '[Search] DownloadFile';
export const DOWNLOAD_FILE_COMPLETE = '[Search] DownloadFileComplete';
export const LOAD_DOCUMENT_DETAIL = '[Search] Load Detail';
export const LOAD_DOCUMENT_DETAIL_COMPLETE = '[Search] Load Detail Complete';
export const UPSERT_DOCUMENT_METADATA = '[Search] Upsert Meta Data';
export const UPSERT_DOCUMENT_METADATA_COMPLETE = '[Search] Upsert Meta Data Complete';
export const CLEAR_DOCUMENT_DETAIL = '[Search] Clear Document Detail';
export const LOAD_GLENN_DALE_DOCUMENTS = '[Search] Load Glenn Dale Documents';
export const LOAD_GLENN_DALE_DOCUMENTS_COMPLETE = '[Search] Load Glenn Dale Documents Complete';

export class SearchDocumentsAction implements Action {
readonly type = SEARCH_DOCUMENTS;

constructor(public payload: SearchCriteria) { }
}

export class SearchDocumentsCompleteAction implements Action {
  readonly type = SEARCH_DOCUMENTS_COMPLETE;

  constructor(public payload: SearchResult[]) { }
}

export class DownloadFileAction implements Action {
  readonly type = DOWNLOAD_FILE;

  constructor(public payload: KvItem) {}
}

export class DownloadFileCompleteAction implements Action {
  readonly type = DOWNLOAD_FILE_COMPLETE;

  constructor(public payload: DownloadedDocument) {}
}

export class LoadDocumentDetailAction implements Action {
  readonly type = LOAD_DOCUMENT_DETAIL;

  constructor(public payload: number) {}
}

export class LoadDocumentDetailCompleteAction implements Action {
  readonly type = LOAD_DOCUMENT_DETAIL_COMPLETE;

  constructor(public payload: DocumentDetail) { }
}

export class UpsertDocumentMetadataAction implements Action {
  readonly type = UPSERT_DOCUMENT_METADATA;

  constructor(public payload: DocumentDetail) {}
}

export class UpsertDocumentMetadataCompleteAction implements Action {
  readonly type = UPSERT_DOCUMENT_METADATA_COMPLETE;

  constructor(payload: boolean) {}
}

export class ClearDocumentDetailAction implements Action {
  readonly type = CLEAR_DOCUMENT_DETAIL;
}

export class LoadGlennDaleDocumentsAction implements Action {
  readonly type = LOAD_GLENN_DALE_DOCUMENTS;
}

export class LoadGlennDaleDocumentsCompleteAction implements Action {
  readonly type = LOAD_GLENN_DALE_DOCUMENTS_COMPLETE;
  constructor(public payload: DocumentMaster[]){}
}
export type Actions = SearchDocumentsAction | SearchDocumentsCompleteAction |
  DownloadFileAction | DownloadFileCompleteAction | LoadDocumentDetailAction |
  LoadDocumentDetailCompleteAction | UpsertDocumentMetadataAction | UpsertDocumentMetadataCompleteAction |
  ClearDocumentDetailAction | LoadGlennDaleDocumentsAction | LoadGlennDaleDocumentsCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/actions/search.ts